import React from "react";
import EventCalendar from "../../assets/svgcomps/EventCalendarComp";
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";
import ProfileImagePlaceHolder from "../../assets/images/profile_image_placeholder.png";
import moment from "moment";
import { ProfileRecommendationCardProps } from "../../types/profileRecommendation";
import { getAvailabilityColor, getAvailabilityText } from "../../utils/helpers";

const ProfileRecommendationCard: React.FC<{ data: ProfileRecommendationCardProps }> = ({ data }) => {
    const {
        name,
        title,
        description,
        imageUrl,
        availabilityStatus,
        availableFrom,
        displayName,
        onClick,
    } = data;

    const showAvailableDate =
        availabilityStatus === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT && availableFrom;

    return (
        <div
            onClick={() => onClick(`/profile-detail/${displayName}`)}
            className="break-all relative bg-gray-50 border border-gray-300 rounded-lg p-3 flex flex-col items-center text-center cursor-pointer w-[290px] flex-shrink-0"
        >
            {/* IMAGE */}
            <div className="flex flex-col items-center justify-center w-full">
                <img
                    className="w-[70px] h-[70px] rounded-full mb-2 min-h-[70px] object-cover"
                    src={imageUrl || ProfileImagePlaceHolder}
                    alt={`${name} profile`}
                />

                {/* AVAILABILITY */}
                <div className="mb-5 h-[40px]">
                    <div
                        className={`border gap-1 font-medium px-3 py-1 mt-1 text-xs rounded mb-4 items-center ${
                            availabilityStatus === CONSTANTS.AVAILABILITY_IMMEDIATELY_CODE_TXT
                                ? "text-primary-dark"
                                : availabilityStatus === CONSTANTS.AVAILABLE_ON_DATE_CODE_TXT
                                ? "text-black"
                                : "text-orange"
                        }`}
                    >
                        <div className="flex items-center">
                            <EventCalendar fill={getAvailabilityColor(availabilityStatus)} />

                            <p className="m-1">{getAvailabilityText(availabilityStatus)}</p>

                            {showAvailableDate && (
                                <p className="text-center">{moment(availableFrom).format("DD MMM YY")}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* TEXT CONTENT */}
            <div className="h-[125px] w-full overflow-hidden">
                <p
                    className="text-gray-900 max-h-[25px] overflow-hidden text-ellipsis whitespace-nowrap m-auto"
                    title={name}
                >
                    {name}
                </p>

                <p
                    className="text-sm text-gray-500 mb-3 h-[20px] overflow-hidden text-ellipsis whitespace-nowrap"
                    title={title}
                >
                    {title}
                </p>

                <p
                    className="text-sm text-gray-500 mb-3 h-full max-h-[40px] overflow-hidden line-clamp-2"
                    title={description}
                >
                    {description}
                </p>
            </div>

            {/* BUTTON */}
            <div className="flex w-full gap-2">
                <Button
                    on_click_handler={(e: Event) => {
                        e.stopPropagation();
                        onClick(`/profile-detail/${displayName}`);
                    }}
                    btn_label="View Profile"
                    type="secondary"
                    other_classes="z-50 !bg-transparent border border-2 border-gray-300"
                />
            </div>
        </div>
    );
};

export default ProfileRecommendationCard;